import { Download, X } from 'lucide-react'
import { useInstallPrompt } from '@/hooks/useInstallPrompt'
import { Button } from '@/components/ui/button'

/**
 * Mời cài ShopTrack vào màn hình chính.
 *
 * Hai hình thái, vì hai nền tảng cho phép hai mức khác nhau:
 *   - Android/Chrome: một nút bấm là ra hộp thoại cài.
 *   - iOS/iPadOS: KHÔNG có nút nào cả — Safari không cho app tự mở hộp thoại.
 *     Chỉ còn cách chỉ đúng thao tác cho người dùng tự làm. Vì iPad là thiết
 *     bị chính nhắm tới, nhánh này phải rõ ràng chứ không được làm qua loa.
 *
 * Tự ẩn khi đã cài hoặc khi người dùng đã tắt đi — không hỏi lại mỗi lần mở.
 */
export function InstallAppCard({ onClose }: { onClose?: () => void }) {
  const { state, dismissed, promptInstall, dismiss } = useInstallPrompt()

  if (dismissed || state !== 'available') return null

  const close = () => {
    dismiss()
    onClose?.()
  }

  return (
    <div className="rounded-xl border border-rule bg-paperSoft/60 p-3">
      <div className="flex items-start gap-3">
        <div className="flex size-9 shrink-0 items-center justify-center rounded-lg bg-accent/10 text-accent">
          <Download className="size-4" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-medium text-ink">Cài ShopTrack vào máy</p>
        </div>
        <button
          onClick={close}
          aria-label="Không hiện lại"
          className="motion-state -mr-1 -mt-1 rounded-lg p-1.5 text-muted hover:bg-rule/40 hover:text-ink"
        >
          <X className="size-4" />
        </button>
      </div>

      <Button size="sm" className="mt-3 w-full" onClick={() => void promptInstall()}>
        Cài ứng dụng
      </Button>
    </div>
  )
}
